var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center padding-t-1"},[_c('CUSkeletonLoader',{staticClass:"d-inline-flex",attrs:{"type":"checkbox"}}),_c('CUSkeletonLoader',{staticClass:"d-inline-flex margin-l-2",attrs:{"type":"text","width":_vm.labelWidth,"styles":_vm.styles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }